import { server } from "../utils/server";


const getPrevInvestments = (data) =>{
    return server.post("transactions/activeInvestment",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const createTransaction = (data) =>{
    return server.post("transactions/add",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        return err?.response?.data;
    });
}

const getMyInvestments = (data) =>{
    return server.post("transactions/get/ByInvestor",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const confirmPayment = (data) =>{
    return server.post("transactions/investorPayment",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        return err?.response?.data;
    });
}

const confirmUPIRequest = (data) =>{
    return server.post("transactions/confirm-upi-request", data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        return err?.response?.data;
    });
}

const updateTransaction = (data) =>{
    return server.post('transactions/updateTraxn',data)
    .then(res =>{
        return res.data
    })
    .catch(err =>{
        console.log(err)
        return err?.response?.data || { success: false, message: "Network error" }
    })
}

const cancelTransaction = (data) =>{
    console.log(data,"iqqiiqiqi");
    
    return server.post('transactions/cancelTraxn',data)
    .then(res =>{
        return res.data
    })
    .catch(err =>{
        console.log(err)
        return err?.response?.data || { success: false, message: "Network error" }
    })
}
const confirmSecondPartPayment = (data) =>{
    return server.post("transactions/investorPayment/secondpart",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        return err?.response?.data;
    });
}

const checkFracs = (data) =>{
    return server.post("transactions/checkavailability",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
        return err?.response?.data;
    });
}

const createOrder = (data) =>{
    return server.post("transactions/createorder",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}


const createOrderRemAmt = (data) =>{
    return server.post("transactions/createorder/pendingAmt",data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        return err?.response?.data;
    });
}

const getPortfolioDetails = async(data)=>{
    return await server.post(`/transactions/portfolio`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        return err?.response?.data;
        
    })
}

const getPrimaryAndSecondaryPortfolioDetails = async(data)=>{
    return await server.post(`/transactions/primaryAndSecondaryPortfolio`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        return err?.response?.data;
    })
}

const getTransactionByLisitngAndUser = async (data) => {
//   data = {   
//     investorId: "Optional",
//     listingId: "optional",
//     rco: "Boolean optional",
//     statusArray:"Array of status ["CREATED"] optional",
//     pendingAmt: "Optional boolean; false to include transactions with pending amounts, true to exclude them."
//   };
 
const response = await server
    .post("/transactions/transactionOfuserBylisting", data)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("-------getTransactionByLisitngAndUser----------------", err);
    });
  return response;
};

const getBeneficiaryInfo = async (data) => {
    return await server.post(`/beneficiary/getbeneficiary`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        console.log(err);   
    })
}

const updateBeneficiary = async (data) => {
    return await server.post(`/beneficiary/updatebeneficiary`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        console.log(err);
    })
}

const getOptinPendingDetails = async (data) => {
    return await server.post(`/transactions/optinPending`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        console.log(err);
    })
}

const confirmWalletPayment = async (data) => {
    return await server.post(`/transactions/payFromWallet`,data).then((res)=>{
        return res.data;
    }).catch((err)=>{
        console.log(err);
    })
}
const transactionServices = {
    getPrevInvestments,
    createTransaction,
    getMyInvestments,
    confirmSecondPartPayment,
    confirmPayment,
    checkFracs,
    createOrder,
    createOrderRemAmt,
    cancelTransaction,
    updateTransaction,
    getPortfolioDetails,
    getTransactionByLisitngAndUser,
    getBeneficiaryInfo,
    updateBeneficiary,
    getOptinPendingDetails,
    getPrimaryAndSecondaryPortfolioDetails,
    confirmWalletPayment,
    confirmUPIRequest
}

export default transactionServices;